<template>
  <div class="cotton-battery-info">
    <span class="cotton-battery-info_text">{{ batteryPercent }}%</span>
    <div class="cotton-battery-info_icon" :style="{ '--percent': `${batteryPercent}%` }">
      <svg
        class="cotton-is-charging"
        v-if="isCharging"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="20%"
        height="100%"
      >
        <path d="M8 0l6 0 2 12 4 0-8 24-6 0-2-12-4 0z" fill="#ffeb3b" />
      </svg>
      <span class="cotton-battery-info_tips" v-if="!isCharging && batteryPercent < 10">!</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    batteryPercent: {
      type: Number,
      default: 0
    },
    isCharging: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss">
.cotton-battery-info {
  display: flex;
  align-items: center;
  gap: 3px;
  --percent: 0%;
  --color: #000;

  &_text {
    font-size: 14px;
  }

  &_icon {
    width: 32px;
    height: 16px;
    border-radius: 4px;
    border: 2px solid var(--color);
    position: relative;
    box-sizing: border-box;

    display: flex;
    justify-content: center;
    align-items: center;

    .cotton-is-charging {
      position: relative;
      z-index: 2;
      top: -1px;
    }

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 2px;
      transform: translateY(-50%);
      width: min(var(--percent), calc(100% - 5px));
      height: calc(100% - 4px);
      background: var(--color);
    }

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      right: -4px;
      transform: translateY(-50%);

      width: 4px;
      height: 30%;

      background: var(--color);
      border-radius: 0 2px 2px 0;
    }
  }

  .is-charging {
    position: absolute;
    left: 50%;
    top: 44%;
    transform: translate(-50%, -50%);
    height: 100%;
  }

  &_tips {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 10px;
    color: #ff3b3b;

    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
